import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ExtendedAttributeOption } from 'app/library/extended-attribute-options/models/extended-attribute-option';

@Pipe({
    name: 'filterAttributeOption',
})
@Injectable()
export class FilterAttributeOptionPipe implements PipeTransform {
    constructor(private _translateService: TranslateService) {}

    transform(values: ExtendedAttributeOption[], input: string | number): any[] {
        if (!values?.length) {
            return [];
        }

        if (!input) {
            return values;
        }

        const search = String(input).trim().toLowerCase();
        if (!search) {
            return values;
        }

        return values.filter((value) => {
            if (value.valueText) {
                const attributeValue = this._translateService.instant(value.translationKey);

                if (attributeValue.toLowerCase().indexOf(search) > -1) {
                    return true;
                }
            } else if (value.valueNumber || value.valueNumber === 0) {
                const attributeValue = value.valueNumber.toString();

                if (attributeValue.toLowerCase().indexOf(search) > -1) {
                    return true;
                }
            }

            return false;
        });
    }
}
